import { BaseAPI } from "@utils/base-api";
import {
  PaymentMethodListCustomerDto,
} from "@./types/payment-methods/dto/payment-method-list-customer.dto";
import {
  StripeCheckoutSessionDataDto,
} from "@./types/payment-methods/dto/stripe-checkout-session-data.dto";

export interface HasNibblesRecentlyResponse {
  hasPurchasedNibbles: boolean;
  lastOrderDate: string | null;
}

export class PaymentMethodsAPI extends BaseAPI {

  public async getAllPaymentMethods(): Promise<PaymentMethodListCustomerDto> {
    const result = await this.axios.get<PaymentMethodListCustomerDto>("/customer/payment-method/all");
    return result.data;
  }

  public async updatePaymentMethods(): Promise<StripeCheckoutSessionDataDto> {
    const result = await this.axios.post<StripeCheckoutSessionDataDto>("/customer/stripe-checkout/update-card-details");
    return result.data;
  }

}
